import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

/** 
 * Where one number's engagement lands once the service starts on the date being applied 
 */
export interface CommitmentMove {
  subscription_id: string;
  name: string;
  sender: string;
  current: number | null;
  proposed: number | null;
}

interface SetOnboardingDatePayload {
  company_id: string;
  onboarding_date: string | null; // `YYYY-MM-DD`, or null to drop the date and open the service
  preview?: boolean; // Compute the engagement moves and write nothing
  commitments?: Record<string, number | null>; // The moves as corrected in the recap, keyed by subscription
}

interface SetOnboardingDateResponse {
  company_id: string;
  onboarding_date: number | null;
  commitments?: CommitmentMove[];
  next_billing_date?: number | null;
  onboarding_pending?: boolean;
}

async function setOnboardingDate(
  payload: SetOnboardingDatePayload,
  auth: Authentication
): Promise<SetOnboardingDateResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/stripe/backoffice/onboarding-date',
      payload,
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('setOnboardingDate error:', e);
    throw new SetOnboardingDateFailure(e.message);
  }
}

export class SetOnboardingDateFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default setOnboardingDate;
